module.exports = __webpack_public_path__ + "static/img/hyyy_ct_c.3e25e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/hyyy_ct_c.png
// module id = V1Cc
// module chunks = 1